import { createFileRoute } from '@tanstack/react-router';
import { ContactEditorPage } from '@/pages/member-portal/contacts/ContactEditorPage';

// Contact editor. `$id` is either a contact id (edit) or the literal `new`.
function MemberPortalContactEditorRoute() {
	return <ContactEditorPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/contacts/$id')({
	component: MemberPortalContactEditorRoute,
});
